import { Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from './Dashboard'
import Businesses from './Businesses'
import Advertisements from './Advertisements'
import Credits from './Credits'
import Notifications from './Notifications'
import Profile from './Profile'

export default function Merchant() {
  return (
    <Routes>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="businesses" element={<Businesses />} />
      <Route path="advertisements" element={<Advertisements />} />
      <Route path="credits" element={<Credits />} />
      <Route path="tokens" element={<Navigate to="/merchant/credits" replace />} />
      <Route path="notifications" element={<Notifications />} />
      <Route path="profile" element={<Profile />} />
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  )
}